<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="tasks"
        @update:filter="reset">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.edit.open(0)">新建</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="任务类型">
            <el-select v-model="filter.typeValue" clearable placeholder="请选择">
              <el-option
                  v-for="item in taskTypes"
                  :key="item.itemValue"
                  :label="item.itemName"
                  :value="item.itemValue"/>
            </el-select>
          </vm-search>
          <vm-search label="任务编号">
            <el-input v-model.trim="filter.taskNo" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="任务名称">
            <el-input v-model.trim="filter.taskName" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="任务状态">
            <el-select v-model="selectedIds" multiple clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.taskStatus)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="创建人" :label-width="67">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="计划开始日期">
            <el-date-picker
                v-model="planStartDate"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="planStartDateChange"/>
          </vm-search>
          <vm-search label="计划完成日期">
            <el-date-picker
                v-model="planEndDate"
                :picker-options="pickerOptions"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="planEndDateChange"/>
          </vm-search>
          <vm-search label="负责人" :label-width="67">
            <el-input v-model.trim="filter.leader" placeholder="请输入" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column align="center" label="任务编号" width="120">
        <template slot-scope="scope">
          <a @click="$refs.edit.open(scope.row.pkid, true)">{{scope.row.taskNo}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="taskName" width="250" label="任务名称" show-overflow-tooltip/>
      <el-table-column prop="taskTypeName" width="80" label="任务类型" align="center"/>
      <el-table-column prop="taskDesc" width="300" label="任务描述" show-overflow-tooltip/>
      <el-table-column prop="projectName" width="120" label="所属项目" show-overflow-tooltip/>
      <el-table-column prop="leader" align="center" label="负责人" width="100"/>
      <el-table-column prop="status" align="center" label="任务状态" width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="info" effect="dark">未启动</el-tag>
          <el-tag v-else-if="scope.row.status === 2" effect="dark">开发中</el-tag>
          <el-tag v-else-if="scope.row.status === 3" type="warning" effect="dark">开发完成</el-tag>
          <el-tag v-else-if="scope.row.status === 4" type="danger" effect="dark">已测试</el-tag>
          <el-tag v-else type="success" effect="dark">已发布</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="planBeginDate" align="center" label="计划开始日期" width="100"/>
      <el-table-column prop="planFinishDate" align="center" label="计划完成日期" width="100"/>
      <el-table-column prop="beginDate" align="center" label="实际开始日期" width="100"/>
      <el-table-column prop="finishDate" align="center" label="实际完成日期" width="100"/>
      <el-table-column prop="creatorName" align="center" label="创建人" width="100"/>
      <el-table-column prop="createdTime" align="center" label="创建时间" width="140"/>
      <el-table-column label="操作" align="center" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button :disabled="isAuth(scope.row)" type="info" @click="$refs.edit.open(scope.row.pkid)">
            编辑
          </el-button>
          <el-button :disabled="isDeleteAuth(scope.row)" type="danger" @click="deleteHandle(scope.row.pkid)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
    <task-edit ref="edit" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import TaskEdit from "@/views/projectManage/task/TaskEdit";
  import constant from "@/util/constant";
  import auth from "@/util/loginUtil";
  import TaskListTree from "@/views/projectManage/task/TaskListTree";

  export default {
    name: "Task",
    components: { VmTable, VmSearch, TaskEdit, TaskListTree },

    data() {
      return {
        selectedIds:[],
        authName: auth.getUserName(),
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        planStartDate: "",
        planEndDate: "",
        url: "tasks",
        constant,
        currentUserId: auth.getUserId(),
        tableData: [],
        taskTypes: [],
        filter: {
          projectId: 0,
          taskNo: "",
          taskName: "",
          statusList: "",
          projectName: "",
          creatorName: "",
          planBeginDateBegin: "",
          planBeginDateEnd: "",
          planFinishDateBegin: "",
          planFinishDateEnd: "",
          typeValue: "",
        },
      };
    },

    watch: {
      // 监听选中项的变化，自动更新字符串值
      selectedIds: {
        handler(newVal) {
          if(newVal.length > 0) {
            this.filter.statusList = newVal.join(",");
          } else {
            this.filter.statusList = "";
          }
        },
        deep: true,
      },
    },

    mounted() {
      this.getList(1);
      this.getTaskTypeList();
    },

    methods: {
      // 权限控制（编辑）
      isAuth(data) {
        if (this.authName === "admin") {
          return false;
        } else if (data.isProjectTeam) {
          return false;
        } else {
          return true;
        }
      },

      // 权限控制（删除）
      isDeleteAuth(data) {
        if (this.authName === "admin") {
          return false;
        } else if (data.status === 5) {
          return true;
        } else if (data.creatorId === this.currentUserId) {
          return false;
        } else {
          return true;
        }
      },

      reset() {
        this.planStartDate = "";
        this.planEndDate = "";
        this.filter.planBeginDateBegin = "";
        this.filter.planBeginDateEnd = "";
        this.filter.planFinishDateBegin = "";
        this.filter.planFinishDateEnd = "";
        this.filter.statusList = "";
        this.selectedIds = [];
      },

      planStartDateChange(date) {
        if (date !== null) {
          this.filter.planBeginDateBegin = date[0];
          this.filter.planBeginDateEnd = date[1];
        } else {
          this.filter.planBeginDateBegin = "";
          this.filter.planBeginDateEnd = "";
        }
      },

      planEndDateChange(date) {
        if (date !== null) {
          this.filter.planFinishDateBegin = date[0];
          this.filter.planFinishDateEnd = date[1];
        } else {
          this.filter.planFinishDateBegin = "";
          this.filter.planFinishDateEnd = "";
        }
      },

      getList(pageNo) {
        this.$refs.vmTable.getList(pageNo);
      },

      // 获取任务类型列表
      getTaskTypeList() {
        this.$http.get("basic", "systemItems/selectByItemType/taskType").then(res => {
          this.taskTypes = res;
        });
      },

      deleteHandle(pkid) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http
            .delete("basic", "tasks", pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>
.searchBox {
  border: 1px solid #EBEEF5;
  background-color: #f4f7fa;
  margin-bottom: 10px;
  padding: 8px 10px;
}
</style>